import React from "react";

const PipelineStageTag = ({ name, color }) => (
    <span
        className="crm-stage-tag"
        style={{ backgroundColor: color || "#6b7280" }}
    >
        {name}
    </span>
);

export default PipelineStageTag;
